import {DVMesh} from "../_snowpack/pkg/@thi.ng/geom-voronoi.js";
import * as g from "../_snowpack/pkg/@thi.ng/geom.js";
import {KdTreeSet} from "../_snowpack/pkg/@thi.ng/geom-accel.js";
import {samplePoisson} from "../_snowpack/pkg/@thi.ng/poisson.js";
import {randMinMax2} from "../_snowpack/pkg/@thi.ng/vectors.js";
export function triangulation(element) {
  const index = new KdTreeSet(2);
  const palette = ["#FFF", "#F00", "#00F", "#28975A", "#1D6F42", "#175733", "#103D24"];
  const height = element.clientHeight;
  const width = element.clientWidth;
  const pts = samplePoisson({
    index,
    points: () => randMinMax2(null, [-width * 0.1, -height * 0.1], [width * 1.1, height * 1.1]),
    density: 40,
    iter: 2,
    max: width * height / 2e3,
    quality: 500
  });
  const delaunay = (points, width2, height2) => {
    const mesh = new DVMesh(points);
    const bounds = [[0, 0], [0, height2], [width2, height2], [width2, 0]];
    const web = mesh.delaunay(bounds).map((p) => g.polygon(p));
    return web;
  };
  const svg = g.asSvg(g.svgDoc({
    viewBox: `0 0 ${width} ${height}`,
    preserveAspectRatio: "xMidYMid slice",
    fill: "none",
    stroke: "blue",
    style: `background-color: ${palette[5]}`
  }, g.group({id: "delaunay", stroke: palette[4], "stroke-width": 0.5}, delaunay(pts, width, height))));
  element.innerHTML = svg;
}
